module.exports = __webpack_public_path__ + "img/swirlmarks_overlay.eb6b91fb.jpeg";